import { getFirestore } from '@firebase/firestore'
import { FIREBASE_CONFIG } from 'config'
import { initializeApp } from 'firebase/app'
import { getAuth, User } from 'firebase/auth'
import { useCallback, useEffect, useState } from 'react'

export const app = initializeApp(FIREBASE_CONFIG)
export const auth = getAuth()
export const db = getFirestore(app)

export const useAuthState = () => {
  const [loading, setLoading] = useState(true)

  const [user, setUser] = useState<User | undefined | null>(auth.currentUser)
  const onAuthStateChanged = useCallback(
    (user: User | null) => {
      setUser(user)
      if (loading) setLoading(false)
    },
    [loading],
  )

  useEffect(() => {
    const authStateChangeUnsubscribe = getAuth().onAuthStateChanged(
      onAuthStateChanged,
    )
    return authStateChangeUnsubscribe
  }, [onAuthStateChanged])

  return { user, loading }
}
